<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M10.5303 4.66968C10.2374 4.37679 9.76257 4.37679 9.46968 4.66968L7.06968 7.06968C6.77678 7.36258 6.77678 7.83745 7.06968 8.13034C7.36257 8.42324 7.83744 8.42324 8.13034 8.13034L10 6.26067L11.8697 8.13034C12.1626 8.42324 12.6374 8.42324 12.9303 8.13034C13.2232 7.83745 13.2232 7.36258 12.9303 7.06968L10.5303 4.66968Z"
            fill="#8E8E93"
        />
    </svg>
</template>
